import { render, staticRenderFns } from "./PartQuantitiesView.vue?vue&type=template&id=2b0f749b&scoped=true&"
import script from "./PartQuantitiesView.vue?vue&type=script&lang=js&"
export * from "./PartQuantitiesView.vue?vue&type=script&lang=js&"
import style0 from "./PartQuantitiesView.vue?vue&type=style&index=0&id=2b0f749b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0f749b",
  null
  
)

export default component.exports